import React, { useState, useEffect, useCallback } from 'react';
import CampoDataHora from '../components/CampoDataHora';
import { useNavigate } from 'react-router-dom';

function token() { return localStorage.getItem('token'); }
function api(path, opts = {}) {
  return fetch(path, { ...opts, headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}`, ...(opts.headers || {}) } });
}

const VARIAVEIS = ['{nome}', '{marca}', '{processo}', '{telefone}', '{data}'];

const lbl = { fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 3, display: 'block' };
const inp = { width: '100%', padding: '6px 10px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, boxSizing: 'border-box', fontFamily: 'inherit' };
const btn = (cor = '#0a1628') => ({ background: cor, color: '#fff', border: 'none', borderRadius: 6, padding: '6px 16px', fontSize: 12, fontWeight: 600, cursor: 'pointer' });
const btnOut = { background: '#fff', color: '#374151', border: '1px solid #d1d5db', borderRadius: 6, padding: '6px 14px', fontSize: 12, cursor: 'pointer' };

function statusBadge(s) {
  if (s === 'enviado') return { label: 'Enviado', bg: '#f0fdf4', cor: '#16a34a' };
  if (s === 'falhou') return { label: 'Falhou', bg: '#fef2f2', cor: '#dc2626' };
  return { label: 'Agendado', bg: '#fffbeb', cor: '#d97706' };
}

function fmtDt(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  return d.toLocaleDateString('pt-BR') + ' ' + d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
}

// ── Aba Templates ─────────────────────────────────────────────────────────────
function AbaTemplates() {
  const [lista, setLista] = useState([]);
  const [form, setForm] = useState({ titulo: '', texto: '' });
  const [editando, setEditando] = useState(null);
  const [salvando, setSalvando] = useState(false);

  const carregar = useCallback(() => {
    api('/comunicacao/templates').then(r => r.json()).then(setLista).catch(() => {});
  }, []);

  useEffect(() => { carregar(); }, [carregar]);

  async function salvar() {
    if (!form.titulo.trim() || !form.texto.trim()) return alert('Preencha título e texto.');
    setSalvando(true);
    if (editando) {
      await api(`/comunicacao/templates/${editando}`, { method: 'PUT', body: JSON.stringify(form) });
    } else {
      await api('/comunicacao/templates', { method: 'POST', body: JSON.stringify(form) });
    }
    setSalvando(false);
    setForm({ titulo: '', texto: '' });
    setEditando(null);
    carregar();
  }

  async function excluir(id) {
    if (!window.confirm('Excluir este template?')) return;
    await api(`/comunicacao/templates/${id}`, { method: 'DELETE' });
    carregar();
  }

  function editar(t) {
    setEditando(t._id);
    setForm({ titulo: t.titulo, texto: t.texto });
    window.scrollTo(0, 0);
  }

  function inserirVariavel(v) {
    setForm(f => ({ ...f, texto: f.texto + v }));
  }

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20, alignItems: 'start' }}>
      {/* Formulário */}
      <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: 16 }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: '#0a1628', marginBottom: 14 }}>
          {editando ? 'Editar Template' : 'Novo Template'}
        </div>
        <div style={{ marginBottom: 10 }}>
          <label style={lbl}>Título</label>
          <input style={inp} value={form.titulo} onChange={e => setForm(f => ({ ...f, titulo: e.target.value }))} placeholder="Ex: Processo Deferido" />
        </div>
        <div style={{ marginBottom: 8 }}>
          <label style={lbl}>Texto da Mensagem</label>
          <textarea style={{ ...inp, minHeight: 120, resize: 'vertical' }} value={form.texto}
            onChange={e => setForm(f => ({ ...f, texto: e.target.value }))}
            placeholder="Ex: Olá {nome}, seu processo da marca {marca} foi deferido!" />
        </div>
        <div style={{ marginBottom: 12 }}>
          <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 5 }}>Clique para inserir variável:</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
            {VARIAVEIS.map(v => (
              <button key={v} onClick={() => inserirVariavel(v)}
                style={{ background: '#f0f4ff', color: '#1d4ed8', border: '1px solid #bfdbfe', borderRadius: 4, padding: '2px 8px', fontSize: 11, cursor: 'pointer' }}>
                {v}
              </button>
            ))}
          </div>
        </div>
        {form.texto && (
          <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 6, padding: 10, marginBottom: 12 }}>
            <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 4 }}>Pré-visualização:</div>
            <div style={{ fontSize: 13, color: '#374151', whiteSpace: 'pre-wrap' }}>
              {form.texto.replace(/\{nome\}/g, 'João Silva').replace(/\{marca\}/g, 'MINHABRAND').replace(/\{processo\}/g, '912345678').replace(/\{telefone\}/g, '(11) 99999-9999').replace(/\{data\}/g, new Date().toLocaleDateString('pt-BR'))}
            </div>
          </div>
        )}
        <div style={{ display: 'flex', gap: 8 }}>
          <button style={btn()} onClick={salvar} disabled={salvando}>{salvando ? 'Salvando...' : editando ? 'Atualizar' : 'Salvar Template'}</button>
          {editando && <button style={btnOut} onClick={() => { setEditando(null); setForm({ titulo: '', texto: '' }); }}>Cancelar</button>}
        </div>
      </div>

      {/* Lista */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {lista.length === 0 ? (
          <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 8, padding: 24, textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>
            Nenhum template cadastrado.
          </div>
        ) : lista.map(t => (
          <div key={t._id} style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: 14 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 6 }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: '#0a1628' }}>{t.titulo}</div>
              <div style={{ display: 'flex', gap: 6 }}>
                <button style={{ ...btnOut, padding: '3px 10px', fontSize: 11 }} onClick={() => editar(t)}>Editar</button>
                <button style={{ ...btn('#dc2626'), padding: '3px 10px', fontSize: 11 }} onClick={() => excluir(t._id)}>Excluir</button>
              </div>
            </div>
            <div style={{ fontSize: 12, color: '#6b7280', whiteSpace: 'pre-wrap', lineHeight: 1.5 }}>{t.texto}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ── Aba Agendar ───────────────────────────────────────────────────────────────
function AbaAgendar({ onAgendado }) {
  const [templates, setTemplates] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [busca, setBusca] = useState('');
  const [clienteSel, setClienteSel] = useState(null);
  const [templateSel, setTemplateSel] = useState(null);
  const [textoPrev, setTextoPrev] = useState('');
  const [agendadoPara, setAgendadoPara] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [anexos, setAnexos] = useState([]);      // [{ arquivo, nome, tamanho }]
  const [subindo, setSubindo] = useState(false);
  // Destino: 'cadastro' (clientes) · 'crm' (oportunidades) · 'parceiros' ·
  // 'avulso' (digita o número na hora). O card do CRM chega aqui por URL
  // (?para_tel=&para_nome=) já com o contato preenchido no modo avulso.
  const paramsIniciais = new URLSearchParams(window.location.search);
  const telParam = (paramsIniciais.get('para_tel') || '').trim();
  const nomeParam = (paramsIniciais.get('para_nome') || '').trim();
  const [modoDestino, setModoDestino] = useState(telParam ? 'avulso' : 'cadastro');
  const [avulsoTel, setAvulsoTel] = useState(telParam);
  const [avulsoNome, setAvulsoNome] = useState(nomeParam);
  // Listas do CRM e dos parceiros: buscadas uma vez, filtradas na digitação
  const [fontes, setFontes] = useState({});
  const [buscaFonte, setBuscaFonte] = useState('');
  useEffect(() => {
    if (!['crm', 'parceiros'].includes(modoDestino) || fontes[modoDestino]) return;
    const url = modoDestino === 'crm' ? '/oportunidades' : '/parceiros';
    api(url).then(r => r.json()).then(arr => {
      const itens = (Array.isArray(arr) ? arr : [])
        .map(x => modoDestino === 'crm'
          ? { nome: x.nome_cliente || '', telefone: x.telefone || '', extra: [x.etapa, x.closer].filter(Boolean).join(' · ') }
          : { nome: x.nome || '', telefone: x.telefone || '', extra: [x.tipo, x.empresa || x.cidade_uf].filter(Boolean).join(' · ') })
        .filter(x => x.nome);
      setFontes(f => ({ ...f, [modoDestino]: itens }));
    }).catch(() => setFontes(f => ({ ...f, [modoDestino]: [] })));
  }, [modoDestino, fontes]);
  // De onde sai: '' = Contato da Preserva; senão, id da sessão pessoal
  const [remetentes, setRemetentes] = useState([]);
  const [remetenteSel, setRemetenteSel] = useState('');
  // Cartões minimizáveis (pedido 18/08): escolheu numa fase, ela se fecha e
  // vira uma linha de resumo — o fluxo inteiro cabe na tela sem rolagem.
  // Chegando do CRM com o contato pronto, o destino já abre minimizado.
  const [fechadas, setFechadas] = useState(telParam ? { destino: true } : {});
  const fecharSec = (k) => setFechadas(f => ({ ...f, [k]: true }));
  const cartao = (id, titulo, resumo, conteudo) => {
    const fechado = !!fechadas[id];
    return (
      <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8 }}>
        <div onClick={() => setFechadas(f => ({ ...f, [id]: !f[id] }))}
          title={fechado ? 'Clique pra abrir' : 'Clique pra minimizar'}
          style={{ padding: '11px 14px', display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', userSelect: 'none' }}>
          <span style={{ fontSize: 13, fontWeight: 700, color: '#0a1628', whiteSpace: 'nowrap' }}>{titulo}</span>
          {fechado && resumo
            ? <span style={{ fontSize: 12, color: '#15803d', fontWeight: 600, flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', textAlign: 'right' }}>✓ {resumo}</span>
            : <span style={{ flex: 1 }} />}
          <span style={{ color: '#9ca3af', fontSize: 11 }}>{fechado ? '▸' : '▾'}</span>
        </div>
        {!fechado && <div style={{ padding: '0 14px 14px' }}>{conteudo}</div>}
      </div>
    );
  };

  useEffect(() => {
    api('/comunicacao/templates').then(r => r.json()).then(setTemplates).catch(() => {});
    api('/comunicacao/remetentes').then(r => r.json())
      .then(d => setRemetentes(Array.isArray(d) ? d : []))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!busca.trim()) { setClientes([]); return; }
    const timer = setTimeout(() => {
      api(`/clientes?busca=${encodeURIComponent(busca)}`).then(r => r.json()).then(d => setClientes(Array.isArray(d) ? d.slice(0, 8) : [])).catch(() => {});
    }, 300);
    return () => clearTimeout(timer);
  }, [busca]);

  const clientesFiltrados = clientes;

  function selecionarTemplate(t) {
    setTemplateSel(t);
    fecharSec('template');
    if (clienteSel) {
      const marca = clienteSel.processos?.[0]?.nome_marca || '';
      const processo = clienteSel.processos?.[0]?.numero_processo || '';
      setTextoPrev(t.texto.replace(/\{nome\}/gi, clienteSel.nome || '').replace(/\{marca\}/gi, marca).replace(/\{processo\}/gi, processo).replace(/\{telefone\}/gi, clienteSel.telefone || '').replace(/\{data\}/gi, new Date().toLocaleDateString('pt-BR')));
    } else {
      setTextoPrev(t.texto);
    }
  }

  function selecionarCliente(c) {
    setClienteSel(c);
    setBusca('');
    fecharSec('destino');
    if (templateSel) {
      const marca = c.processos?.[0]?.nome_marca || '';
      const processo = c.processos?.[0]?.numero_processo || '';
      setTextoPrev(templateSel.texto.replace(/\{nome\}/gi, c.nome || '').replace(/\{marca\}/gi, marca).replace(/\{processo\}/gi, processo).replace(/\{telefone\}/gi, c.telefone || '').replace(/\{data\}/gi, new Date().toLocaleDateString('pt-BR')));
    }
  }

  // Sobe os arquivos na hora de escolher: o agendamento guarda só as referências
  async function escolherAnexo(e) {
    const fs = [...(e.target.files || [])];
    if (!fs.length) return;
    const grande = fs.find(f => f.size > 20 * 1024 * 1024);
    if (grande) { alert(`"${grande.name}" passa de 20 MB.`); e.target.value = ''; return; }
    if (anexos.length + fs.length > 10) { alert('Máximo de 10 arquivos por mensagem.'); e.target.value = ''; return; }
    setSubindo(true);
    try {
      const fd = new FormData();
      fs.forEach(f => fd.append('arquivo', f));
      // sem Content-Type: o browser põe o boundary do multipart sozinho
      const r = await fetch('/comunicacao/anexo', {
        method: 'POST',
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        body: fd,
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.erro || 'Falha no upload');
      setAnexos(a => [...a, ...(d.anexos || [])]);
      fecharSec('anexo');
    } catch (err) { alert(err.message); }
    setSubindo(false);
    e.target.value = '';
  }

  async function removerAnexo(arquivo) {
    await api(`/comunicacao/anexo/${encodeURIComponent(arquivo)}`, { method: 'DELETE' }).catch(() => {});
    setAnexos(a => a.filter(x => x.arquivo !== arquivo));
  }

  // Destino: cliente do cadastro, contato do CRM, parceiro OU número avulso
  const telDestino = (avulsoTel || '').replace(/\D/g, '');
  const destinoOk = modoDestino === 'avulso' ? telDestino.length >= 10 : !!clienteSel?.telefone;

  // Resumos das fases minimizadas
  const resumoRemetente = (remetentes.find(x => x.id === remetenteSel)?.nome) || 'Contato da Preserva';
  const resumoDestino = modoDestino === 'avulso'
    ? (telDestino.length >= 10 ? `${avulsoNome.trim() ? avulsoNome.trim() + ' · ' : ''}${telDestino}` : '')
    : (clienteSel ? `${clienteSel.nome || ''} · ${clienteSel.telefone || ''}` : '');
  const resumoTemplate = templateSel?.titulo || (textoPrev.trim() ? 'Texto livre' : '');
  const resumoAnexo = anexos.length ? `${anexos.length} arquivo(s)` : '';
  const resumoData = agendadoPara ? fmtDt(new Date(agendadoPara).toISOString()) : '';

  // imediato = true: manda agora (horário = já), sem exigir data marcada
  async function agendar(imediato = false) {
    if (modoDestino === 'avulso') {
      if (telDestino.length < 10) return alert('Digite o número com DDD (ex.: 83 99999-9999).');
    } else {
      if (!clienteSel) return alert(modoDestino === 'crm' ? 'Selecione o contato do CRM.' : modoDestino === 'parceiros' ? 'Selecione o parceiro.' : 'Selecione um cliente.');
      if (!clienteSel.telefone) return alert('Este contato não tem telefone cadastrado.');
    }
    if (!textoPrev.trim() && !anexos.length) return alert('Escreva a mensagem ou anexe um arquivo.');
    if (!imediato && !agendadoPara) return alert('Defina a data e hora do envio.');
    setSalvando(true);
    const resp = await api('/comunicacao/fila', {
      method: 'POST',
      body: JSON.stringify({
        // cliente_id só quando é cliente do cadastro — CRM e parceiro não são clientes
        cliente_id: modoDestino === 'cadastro' ? clienteSel._id : '',
        cliente_nome: modoDestino === 'avulso'
          ? (avulsoNome.trim() || `Avulso · ${avulsoTel}`)
          : (clienteSel.nome || clienteSel.processos?.[0]?.nome_marca || ''),
        telefone: modoDestino === 'avulso' ? telDestino : clienteSel.telefone,
        template_id: templateSel?._id || '',
        template_titulo: templateSel?.titulo || (anexos.length ? '📎 Com anexo' : 'Personalizada'),
        texto_final: textoPrev,
        anexos,
        enviar_por: remetenteSel,
        enviar_por_nome: remetentes.find(x => x.id === remetenteSel)?.nome || '',
        agendado_para: imediato ? new Date().toISOString() : new Date(agendadoPara).toISOString(),
      }),
    });
    setSalvando(false);
    // Antes isto era um await solto: se o backend recusasse (401, validação,
    // erro), a tela dizia "agendada com sucesso" e nada ia pra fila.
    if (!resp.ok) {
      const d = await resp.json().catch(() => ({}));
      return alert(resp.status === 401
        ? 'Sua sessão expirou. Faça login de novo e tente outra vez.'
        : `Não deu pra agendar: ${d.erro || `erro ${resp.status}`}`);
    }
    alert(imediato ? 'Enviando agora! Acompanhe na fila.' : 'Mensagem agendada com sucesso!');
    setClienteSel(null);
    setTemplateSel(null);
    setTextoPrev('');
    setAgendadoPara('');
    setAnexos([]);
    setAvulsoTel('');
    setAvulsoNome('');
    setFechadas({}); // formulário zerado: reabre todas as fases
    onAgendado();
  }

  return (
    // Fluxo em coluna única, na ordem de preenchimento (pedido 18/08):
    // remetente → destino → template → prévia → anexo → data → botões
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14, maxWidth: 640, minWidth: 0 }}>

        {/* Remetente: número da empresa ou o WhatsApp pessoal conectado */}
        {remetentes.length > 1 && cartao('remetente', '1. De onde sai', resumoRemetente, (
          <div style={{ display: 'flex', gap: 6 }}>
            {remetentes.map(r => {
              const on = remetenteSel === r.id;
              const conectado = r.status === 'conectado';
              return (
                <button key={r.id || 'empresa'} onClick={() => { setRemetenteSel(r.id); fecharSec('remetente'); }}
                  disabled={!conectado}
                  title={conectado ? '' : 'Desconectado — conecte em Configurações'}
                  style={{
                    flex: 1, padding: '6px 10px', fontSize: 12, fontWeight: 700, borderRadius: 6,
                    cursor: conectado ? 'pointer' : 'not-allowed', opacity: conectado ? 1 : 0.45,
                    border: '1px solid ' + (on ? '#0a1628' : '#d1d5db'),
                    background: on ? '#0a1628' : '#fff',
                    color: on ? '#fff' : '#374151',
                  }}>
                  {r.id ? '👤 ' : '🏢 '}{r.nome}{conectado ? '' : ' (off)'}
                </button>
              );
            })}
          </div>
        ))}

        {/* Destino: cliente do cadastro ou número digitado na hora */}
        {cartao('destino', '2. Para quem vai', resumoDestino, (<div>
          <div style={{ display: 'flex', gap: 6, marginBottom: 12, flexWrap: 'wrap' }}>
            {[
              { k: 'cadastro', label: '🔍 Cliente' },
              { k: 'crm', label: '🎯 CRM' },
              { k: 'parceiros', label: '🤝 Parceiros' },
              { k: 'avulso', label: '✍️ Avulso' },
            ].map(o => (
              <button key={o.k} onClick={() => { if (modoDestino !== o.k) { setModoDestino(o.k); setClienteSel(null); setBusca(''); setBuscaFonte(''); } }}
                style={{
                  flex: '1 1 100px', padding: '6px 8px', fontSize: 12, fontWeight: 700, borderRadius: 6, cursor: 'pointer',
                  border: '1px solid ' + (modoDestino === o.k ? '#0a1628' : '#d1d5db'),
                  background: modoDestino === o.k ? '#0a1628' : '#fff',
                  color: modoDestino === o.k ? '#fff' : '#374151',
                }}>{o.label}</button>
            ))}
          </div>

          {modoDestino === 'avulso' ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <div>
                <div style={{ fontSize: 11.5, color: '#6b7280', marginBottom: 3 }}>Número com DDD</div>
                <input style={inp} value={avulsoTel} onChange={e => setAvulsoTel(e.target.value)}
                  placeholder="83 99999-9999" inputMode="tel" />
              </div>
              <div>
                <div style={{ fontSize: 11.5, color: '#6b7280', marginBottom: 3 }}>Nome <span style={{ color: '#9ca3af' }}>(opcional, só pra identificar na fila)</span></div>
                <input style={inp} value={avulsoNome} onChange={e => setAvulsoNome(e.target.value)} placeholder="Ex.: João da gráfica" />
              </div>
              {avulsoTel && telDestino.length < 10 && (
                <div style={{ fontSize: 11.5, color: '#b45309' }}>⚠ Faltam dígitos — inclua o DDD.</div>
              )}
              {telDestino.length >= 10 && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <span style={{ fontSize: 11.5, color: '#15803d', fontWeight: 600 }}>✓ Vai para {telDestino}</span>
                  <button onClick={() => fecharSec('destino')}
                    style={{ background: '#16a34a', color: '#fff', border: 'none', borderRadius: 5, padding: '3px 12px', fontSize: 11.5, fontWeight: 700, cursor: 'pointer' }}>
                    ✓ OK — minimizar
                  </button>
                </div>
              )}
            </div>
          ) : clienteSel ? (
            <div style={{ background: '#f0f4ff', border: '1px solid #bfdbfe', borderRadius: 6, padding: '8px 12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <div style={{ fontWeight: 600, fontSize: 13, color: '#0a1628' }}>{clienteSel.nome || clienteSel.processos?.[0]?.nome_marca}</div>
                <div style={{ fontSize: 12, color: '#6b7280' }}>📞 {clienteSel.telefone || 'Sem telefone'}</div>
              </div>
              <button style={btnOut} onClick={() => setClienteSel(null)}>Trocar</button>
            </div>
          ) : modoDestino === 'cadastro' ? (
            <div>
              <input style={inp} value={busca} onChange={e => setBusca(e.target.value)} placeholder="Buscar por nome, marca ou telefone..." />
              {busca && (
                <div style={{ border: '1px solid #e5e7eb', borderRadius: 6, marginTop: 4, overflow: 'hidden', maxHeight: 200, overflowY: 'auto' }}>
                  {clientesFiltrados.length === 0 ? (
                    <div style={{ padding: '8px 12px', fontSize: 12, color: '#9ca3af' }}>Nenhum cliente encontrado</div>
                  ) : clientesFiltrados.map(c => (
                    <div key={c._id} onClick={() => selecionarCliente(c)}
                      style={{ padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid #f3f4f6', fontSize: 13 }}
                      onMouseEnter={e => e.currentTarget.style.background = '#f0f4ff'}
                      onMouseLeave={e => e.currentTarget.style.background = '#fff'}>
                      <div style={{ fontWeight: 600 }}>{c.nome || '(sem nome)'}</div>
                      <div style={{ fontSize: 11, color: '#6b7280' }}>{c.processos?.[0]?.nome_marca} · {c.telefone || 'sem telefone'}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ) : (() => {
            // CRM e Parceiros: lista já carregada, filtro na digitação (sem acento)
            const semAc = (s) => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
            const lista = fontes[modoDestino];
            const achados = (lista || []).filter(x => !buscaFonte.trim() || semAc(x.nome + ' ' + x.telefone + ' ' + x.extra).includes(semAc(buscaFonte)));
            return (
              <div>
                {lista === undefined ? (
                  <div style={{ fontSize: 12, color: '#6b7280' }}>Carregando {modoDestino === 'crm' ? 'oportunidades' : 'parceiros'}…</div>
                ) : (
                  <>
                    <input style={inp} value={buscaFonte} onChange={e => setBuscaFonte(e.target.value)}
                      placeholder={modoDestino === 'crm' ? `Buscar nas ${lista.length} oportunidades…` : `Buscar nos ${lista.length} parceiros…`} />
                    <div style={{ border: '1px solid #e5e7eb', borderRadius: 6, marginTop: 4, overflow: 'hidden', maxHeight: 200, overflowY: 'auto' }}>
                      {achados.length === 0 ? (
                        <div style={{ padding: '8px 12px', fontSize: 12, color: '#9ca3af' }}>Ninguém com esse nome.</div>
                      ) : achados.slice(0, 25).map((c, i) => (
                        <div key={i} onClick={() => c.telefone ? selecionarCliente(c) : alert('Este contato não tem telefone cadastrado.')}
                          style={{ padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid #f3f4f6', fontSize: 13, opacity: c.telefone ? 1 : 0.5 }}
                          onMouseEnter={e => e.currentTarget.style.background = '#f0f4ff'}
                          onMouseLeave={e => e.currentTarget.style.background = '#fff'}>
                          <div style={{ fontWeight: 600 }}>{c.nome}</div>
                          <div style={{ fontSize: 11, color: '#6b7280' }}>{[c.extra, c.telefone || 'sem telefone'].filter(Boolean).join(' · ')}</div>
                        </div>
                      ))}
                      {achados.length > 25 && <div style={{ padding: '4px 12px', fontSize: 10.5, color: '#9ca3af' }}>mostrando 25 de {achados.length} — digite pra refinar</div>}
                    </div>
                  </>
                )}
              </div>
            );
          })()}
        </div>))}

        {/* Template (opcional — dá pra escrever do zero ou só anexar) */}
        {cartao('template', '3. Template', resumoTemplate, (<div>
          <div style={{ fontSize: 11.5, color: '#6b7280', marginBottom: 10 }}>
            Escolha um pronto ou escreva livre na pré-visualização abaixo. <span style={{ color: '#9ca3af' }}>(opcional)</span>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            {templateSel && (
              <button onClick={() => { setTemplateSel(null); setTextoPrev(''); }}
                style={{ alignSelf: 'flex-start', background: '#fff', border: '1px solid #d1d5db', borderRadius: 5, padding: '3px 10px', fontSize: 11.5, color: '#dc2626', fontWeight: 600, cursor: 'pointer', marginBottom: 2 }}>
                × Não usar template
              </button>
            )}
            {templates.length === 0 && <div style={{ fontSize: 12, color: '#9ca3af' }}>Nenhum template cadastrado — escreva livre na pré-visualização.</div>}
            {templates.map(t => (
              <div key={t._id} onClick={() => selecionarTemplate(t)}
                style={{ padding: '8px 12px', border: `1px solid ${templateSel?._id === t._id ? '#0a1628' : '#e5e7eb'}`, borderRadius: 6, cursor: 'pointer', background: templateSel?._id === t._id ? '#f0f4ff' : '#fff', minWidth: 0, overflow: 'hidden' }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: '#0a1628' }}>{t.titulo}</div>
                <div style={{ fontSize: 11, color: '#9ca3af', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{t.texto}</div>
              </div>
            ))}
          </div>
        </div>))}

        {/* Prévia + texto da mensagem (sempre editável) */}
        <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: 16, minWidth: 0, overflowWrap: 'anywhere' }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: '#0a1628', marginBottom: 12 }}>4. Pré-visualização</div>
          {(textoPrev || anexos.length) ? (
            // Cada balão = uma mensagem no WhatsApp, na ordem em que sai
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 16 }}>
              {anexos.map(a => (
                <div key={a.arquivo} style={{ alignSelf: 'flex-end', maxWidth: '92%', background: '#e9fbe9', border: '1px solid #bbf7d0', borderRadius: 12, borderBottomRightRadius: 2, padding: 8 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 7, background: '#fff', border: '1px solid #d1fae5', borderRadius: 8, padding: '8px 10px' }}>
                    <span style={{ fontSize: 20 }}>📄</span>
                    <span style={{ fontSize: 12.5, fontWeight: 600, color: '#111827', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{a.nome}</span>
                  </div>
                </div>
              ))}
              {textoPrev && (
                <div style={{ alignSelf: 'flex-end', maxWidth: '92%', background: '#e9fbe9', border: '1px solid #bbf7d0', borderRadius: 12, borderBottomRightRadius: 2, padding: '12px 14px', fontSize: 14, lineHeight: 1.6, color: '#1a1a1a', whiteSpace: 'pre-wrap' }}>
                  {textoPrev}
                </div>
              )}
              {anexos.length > 0 && (
                <div style={{ fontSize: 11, color: '#9ca3af', textAlign: 'right' }}>
                  {anexos.length === 1 ? '1 arquivo' : `${anexos.length} arquivos`}{textoPrev ? ' + a mensagem' : ''} — {anexos.length + (textoPrev ? 1 : 0)} envios
                </div>
              )}
            </div>
          ) : (
            <div style={{ background: '#f9fafb', borderRadius: 8, padding: 24, textAlign: 'center', color: '#9ca3af', fontSize: 13, marginBottom: 16 }}>
              Escreva a mensagem abaixo, escolha um template ou anexe um arquivo
            </div>
          )}
          {/* Sempre editável: antes só aparecia depois de escolher um template,
              o que impedia escrever do zero */}
          <textarea style={{ ...inp, minHeight: 90, resize: 'vertical' }}
            placeholder={anexos.length ? 'Mensagem que vai depois dos arquivos…' : 'Escreva a mensagem…'}
            value={textoPrev} onChange={e => setTextoPrev(e.target.value)} />
        </div>

        {/* Anexo */}
        {cartao('anexo', '5. Anexo', resumoAnexo, (<div>
          <div style={{ fontSize: 11.5, color: '#6b7280', marginBottom: 10 }}>
            PDF, imagem ou documento — dá pra escolher vários. Saem <strong>antes</strong> da mensagem, um por vez. <span style={{ color: '#9ca3af' }}>(opcional)</span>
          </div>
          {anexos.map((a, i) => (
            <div key={a.arquivo} style={{ display: 'flex', alignItems: 'center', gap: 8, background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 6, padding: '7px 10px', marginBottom: 6 }}>
              <span style={{ fontSize: 11, fontWeight: 800, color: '#15803d', minWidth: 16 }}>{i + 1}º</span>
              <span style={{ fontSize: 16 }}>📎</span>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 12.5, fontWeight: 600, color: '#15803d', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{a.nome}</div>
                <div style={{ fontSize: 11, color: '#6b7280' }}>{(a.tamanho / 1024 / 1024).toFixed(2)} MB</div>
              </div>
              <button onClick={() => removerAnexo(a.arquivo)}
                style={{ background: 'none', border: 'none', color: '#dc2626', fontSize: 16, cursor: 'pointer', fontWeight: 700 }}>×</button>
            </div>
          ))}
          {anexos.length < 10 && (
            <>
              <input type="file" multiple accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg" onChange={escolherAnexo} disabled={subindo}
                style={{ ...inp, height: 'auto', padding: 7, fontSize: 12 }} />
              {subindo && <div style={{ fontSize: 12, color: '#6b7280', marginTop: 6 }}>Enviando…</div>}
            </>
          )}
        </div>))}

        {/* Data/hora */}
        {cartao('data', '6. Data e hora do envio', resumoData, (<div>
          <div style={{ fontSize: 11.5, color: '#9ca3af', marginBottom: 8 }}>Só pra agendar — o Enviar Agora ignora.</div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
            <CampoDataHora style={inp} value={agendadoPara} onChange={setAgendadoPara} />
            {agendadoPara && (
              <button onClick={() => fecharSec('data')}
                style={{ background: '#16a34a', color: '#fff', border: 'none', borderRadius: 5, padding: '5px 12px', fontSize: 11.5, fontWeight: 700, cursor: 'pointer' }}>
                ✓ OK — minimizar
              </button>
            )}
          </div>
          {agendadoPara && (
            <div style={{ background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 6, padding: '8px 12px', fontSize: 12, color: '#92400e', marginTop: 10 }}>
              ⏰ Disparo programado para: <strong>{fmtDt(new Date(agendadoPara).toISOString())}</strong>
            </div>
          )}
        </div>))}

        {/* Confirmar */}
        <div style={{ display: 'flex', gap: 8 }}>
          {/* onClick com arrow: onClick={agendar} passaria o evento do clique
              como 1º argumento e viraria imediato=true sem querer */}
          <button style={{ ...btn('#0a1628'), flex: 1, padding: '10px', fontSize: 14, opacity: destinoOk ? 1 : 0.5 }}
            onClick={() => agendar(true)} disabled={salvando || !destinoOk}>
            {salvando ? 'Enviando...' : '🚀 Enviar Agora'}
          </button>
          <button style={{ ...btn('#16a34a'), flex: 1, padding: '10px', fontSize: 14, opacity: destinoOk ? 1 : 0.5 }}
            onClick={() => agendar(false)} disabled={salvando || !destinoOk}>
            {salvando ? 'Agendando...' : '📅 Agendar Envio'}
          </button>
        </div>
    </div>
  );
}

// ── Aba Fila ──────────────────────────────────────────────────────────────────
function AbaFila({ recarregar }) {
  const [lista, setLista] = useState([]);
  const navigate = useNavigate();

  const carregar = useCallback(() => {
    api('/comunicacao/fila').then(r => r.json()).then(setLista).catch(() => {});
  }, []);

  useEffect(() => { carregar(); }, [carregar, recarregar]);

  async function cancelar(id) {
    if (!window.confirm('Cancelar esta mensagem agendada?')) return;
    await api(`/comunicacao/fila/${id}`, { method: 'DELETE' });
    carregar();
  }

  // Modal de leitura/edição: clique na linha abre o texto completo; dá pra
  // corrigir a mensagem e o horário SEM perder o agendamento
  const [msgAberta, setMsgAberta] = useState(null);
  const [textoEdit, setTextoEdit] = useState('');
  const [quandoEdit, setQuandoEdit] = useState('');
  const [salvandoEdit, setSalvandoEdit] = useState(false);
  const paraInputLocal = (iso) => {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    const p = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
  };
  const abrirMsg = (m) => { setMsgAberta(m); setTextoEdit(m.texto_final || ''); setQuandoEdit(paraInputLocal(m.agendado_para)); };

  async function salvarEdicaoMsg() {
    if (!msgAberta || salvandoEdit) return;
    if (!quandoEdit) return alert('Defina a data e hora do envio.');
    setSalvandoEdit(true);
    const r = await api(`/comunicacao/fila/${msgAberta._id}`, {
      method: 'PUT',
      body: JSON.stringify({ texto_final: textoEdit, agendado_para: new Date(quandoEdit).toISOString() }),
    }).catch(() => null);
    setSalvandoEdit(false);
    if (!r || !r.ok) {
      let det = ''; try { det = (await r.json()).erro || ''; } catch { /* não-JSON */ }
      return alert(`Não consegui salvar (HTTP ${r?.status || 'rede'}). ${det}`.trim());
    }
    setMsgAberta(null);
    carregar();
  }

  const agendadas = lista.filter(m => m.status === 'agendado');

  return (
    <div>
      {agendadas.length === 0 ? (
        <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 8, padding: 32, textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>
          Nenhuma mensagem na fila.
        </div>
      ) : (
        <div style={{ border: '1px solid #e5e7eb', borderRadius: 8, overflow: 'hidden' }}>
          <div style={{ background: '#0a1628', display: 'grid', gridTemplateColumns: '2fr 1fr 1fr auto', gap: 0, padding: '8px 14px' }}>
            {['Cliente / Mensagem', 'Template', 'Disparo em', ''].map(h => (
              <span key={h} style={{ fontSize: 11, fontWeight: 700, color: '#fff', textTransform: 'uppercase', letterSpacing: '0.04em' }}>{h}</span>
            ))}
          </div>
          {agendadas.map((m, i) => (
            <div key={m._id} onClick={() => abrirMsg(m)} title="Clique pra ler a mensagem completa e editar se precisar"
              onMouseEnter={e => e.currentTarget.style.background = '#f0f4ff'}
              onMouseLeave={e => e.currentTarget.style.background = i % 2 === 0 ? '#fafafa' : '#fff'}
              style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr auto', alignItems: 'center', gap: 0, padding: '10px 14px', borderBottom: i < agendadas.length - 1 ? '1px solid #f3f4f6' : 'none', background: i % 2 === 0 ? '#fafafa' : '#fff', cursor: 'pointer' }}>
              <div>
                <div style={{ fontSize: 13, fontWeight: 600, color: '#0a1628' }}>{m.cliente_nome}</div>
                {(() => {
                  const ax = (m.anexos?.length ? m.anexos : (m.anexo_nome ? [{ nome: m.anexo_nome }] : []));
                  return ax.length ? (
                    <div style={{ fontSize: 11, color: '#15803d', fontWeight: 600, marginTop: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 300 }}>
                      📎 {ax.map(a => a.nome).join(' · ')}
                    </div>
                  ) : null;
                })()}
                <div style={{ fontSize: 11, color: '#6b7280', marginTop: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 300 }}>{m.texto_final || <em style={{ color: '#9ca3af' }}>(só o arquivo, sem legenda)</em>}</div>
                <div style={{ fontSize: 11, color: '#9ca3af' }}>📞 {m.telefone}</div>
              </div>
              <div>
                <div style={{ fontSize: 12, color: '#374151' }}>{m.template_titulo}</div>
                {/* De qual número a mensagem sai */}
                <div style={{ fontSize: 11, fontWeight: 600, color: m.enviar_por ? '#1d4ed8' : '#6b7280', marginTop: 2 }}>
                  {m.enviar_por ? `👤 sai de: ${m.enviar_por_nome || 'WhatsApp pessoal'}` : '🏢 sai de: Contato da Preserva'}
                </div>
              </div>
              <div style={{ fontSize: 12, color: '#d97706', fontWeight: 600 }}>{fmtDt(m.agendado_para)}</div>
              <button style={{ ...btn('#dc2626'), padding: '4px 12px', fontSize: 11 }} onClick={e => { e.stopPropagation(); cancelar(m._id); }}>Cancelar</button>
            </div>
          ))}
        </div>
      )}

      {/* Ler/editar mensagem agendada — salva e o envio continua programado */}
      {msgAberta && (
        <div onClick={() => setMsgAberta(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1300, padding: 16 }}>
          <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 10, width: 560, maxWidth: '96vw', maxHeight: '92vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
            <div style={{ background: '#0a1628', padding: '10px 16px', borderRadius: '10px 10px 0 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <div style={{ color: '#fff', fontSize: 14, fontWeight: 700 }}>✉️ Mensagem agendada</div>
                <div style={{ color: '#94a3b8', fontSize: 11 }}>{msgAberta.cliente_nome} · 📞 {msgAberta.telefone}{msgAberta.template_titulo ? ` · ${msgAberta.template_titulo}` : ''} · sai de: {msgAberta.enviar_por ? (msgAberta.enviar_por_nome || 'WhatsApp pessoal') : 'Contato da Preserva'}</div>
              </div>
              <button onClick={() => setMsgAberta(null)} style={{ background: 'none', border: 'none', color: '#94a3b8', fontSize: 20, cursor: 'pointer', lineHeight: 1 }}>×</button>
            </div>
            <div style={{ padding: 16 }}>
              {(msgAberta.anexos?.length > 0) && (
                <div style={{ fontSize: 12, color: '#15803d', fontWeight: 600, marginBottom: 8 }}>
                  📎 {msgAberta.anexos.map(a => a.nome).join(' · ')} <span style={{ color: '#9ca3af', fontWeight: 400 }}>(saem antes da mensagem)</span>
                </div>
              )}
              <div style={{ fontSize: 11.5, fontWeight: 600, color: '#6b7280', marginBottom: 4 }}>Texto da mensagem</div>
              <textarea value={textoEdit} onChange={e => setTextoEdit(e.target.value)}
                style={{ ...inp, width: '100%', boxSizing: 'border-box', minHeight: 180, resize: 'vertical', lineHeight: 1.5, marginBottom: 12 }} />
              <div style={{ fontSize: 11.5, fontWeight: 600, color: '#6b7280', marginBottom: 4 }}>Disparo em</div>
              <div style={{ marginBottom: 14 }}><CampoDataHora value={quandoEdit} onChange={setQuandoEdit} style={inp} /></div>
              <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                <button onClick={salvarEdicaoMsg} disabled={salvandoEdit}
                  style={{ ...btn('#16a34a'), padding: '8px 18px', fontSize: 13, opacity: salvandoEdit ? 0.6 : 1 }}>
                  {salvandoEdit ? 'Salvando…' : '💾 Salvar — continua programado'}
                </button>
                <button onClick={() => setMsgAberta(null)} style={{ background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db', borderRadius: 6, padding: '8px 14px', fontSize: 13, cursor: 'pointer' }}>Fechar</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── Aba Histórico ─────────────────────────────────────────────────────────────
function AbaHistorico() {
  const [lista, setLista] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api('/comunicacao/historico').then(r => r.json()).then(setLista).catch(() => {});
  }, []);

  return (
    <div>
      {lista.length === 0 ? (
        <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 8, padding: 32, textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>
          Nenhuma mensagem enviada ainda.
        </div>
      ) : (
        <div style={{ border: '1px solid #e5e7eb', borderRadius: 8, overflow: 'hidden' }}>
          <div style={{ background: '#0a1628', display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 80px', gap: 0, padding: '8px 14px' }}>
            {['Cliente / Mensagem', 'Template', 'Enviado em', 'Status'].map(h => (
              <span key={h} style={{ fontSize: 11, fontWeight: 700, color: '#fff', textTransform: 'uppercase', letterSpacing: '0.04em' }}>{h}</span>
            ))}
          </div>
          {lista.map((m, i) => {
            const st = statusBadge(m.status);
            return (
              <div key={m._id} style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 80px', alignItems: 'center', gap: 0, padding: '10px 14px', borderBottom: i < lista.length - 1 ? '1px solid #f3f4f6' : 'none', background: i % 2 === 0 ? '#fafafa' : '#fff' }}>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 600, color: '#0a1628', cursor: m.cliente_id ? 'pointer' : 'default', textDecoration: m.cliente_id ? 'underline' : 'none' }}
                    onClick={() => m.cliente_id && navigate(`/clientes/${m.cliente_id}/editar`)}>
                    {m.cliente_nome}
                  </div>
                  <div style={{ fontSize: 11, color: '#6b7280', marginTop: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 300 }}>{m.texto_final}</div>
                  <div style={{ fontSize: 11, color: '#9ca3af' }}>📞 {m.telefone}</div>
                </div>
                <div style={{ fontSize: 12, color: '#374151' }}>{m.template_titulo}</div>
                <div style={{ fontSize: 12, color: '#374151' }}>{fmtDt(m.enviado_em || m.agendado_para)}</div>
                <span style={{ background: st.bg, color: st.cor, padding: '2px 8px', borderRadius: 4, fontSize: 11, fontWeight: 700 }}>{st.label}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

// ── Aba Comunicado geral ──────────────────────────────────────────────────────
// Escreve uma vez → mensagem individual pra cada pessoa da equipe (sai do
// WhatsApp da empresa pela fila, com retentativa de 24h)
function AbaComunicado({ onEnviado }) {
  const [texto, setTexto] = useState('');
  const [publico, setPublico] = useState('todos');
  const [quando, setQuando] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [formatando, setFormatando] = useState(false);
  const [antesDeFormatar, setAntesDeFormatar] = useState(null); // pra desfazer
  const [equipe, setEquipe] = useState([]);
  const [marcados, setMarcados] = useState([]);
  const [numeros, setNumeros] = useState({}); // {userId: 'ambos'|'trabalho'|'pessoal'}
  // De onde sai: '' = Contato da Preserva; senão, sessão pessoal (igual à aba Agendar)
  const [remetentes, setRemetentes] = useState([]);
  const [remetenteSel, setRemetenteSel] = useState('');

  useEffect(() => {
    api('/usuarios').then(r => r.json())
      .then(us => setEquipe((us || []).filter(u => u.email !== 'clau@preservamarcas.com.br')))
      .catch(() => {});
    api('/comunicacao/remetentes').then(r => r.json())
      .then(d => setRemetentes(Array.isArray(d) ? d : []))
      .catch(() => {});
  }, []);

  async function formatar() {
    if (!texto.trim()) return setResultado({ erro: 'Escreva o rascunho antes de formatar.' });
    setFormatando(true); setResultado(null);
    const r = await api('/comunicacao/formatar', { method: 'POST', body: JSON.stringify({ rascunho: texto, publico: 'equipe' }) })
      .then(x => x.json()).catch(() => ({ erro: 'Falha ao formatar.' }));
    setFormatando(false);
    if (r.erro) return setResultado({ erro: r.erro });
    setAntesDeFormatar(texto);
    setTexto(r.texto);
  }

  async function enviar() {
    if (!texto.trim()) return setResultado({ erro: 'Escreva o comunicado.' });
    setEnviando(true); setResultado(null);
    const body = { texto: texto.trim(), publico };
    if (publico === 'selecionados') { body.ids = marcados; body.numeros = numeros; }
    if (quando) body.agendado_para = new Date(quando).toISOString();
    body.enviar_por = remetenteSel;
    body.enviar_por_nome = remetentes.find(x => x.id === remetenteSel)?.nome || '';
    const r = await api('/comunicacao/comunicado', { method: 'POST', body: JSON.stringify(body) })
      .then(x => x.json()).catch(() => ({ erro: 'Falha ao enviar.' }));
    setResultado(r);
    setEnviando(false);
    if (r.ok) { setTexto(''); setQuando(''); onEnviado && onEnviado(); }
  }

  const inp2 = { padding: '6px 10px', borderRadius: 6, border: '1px solid #d1d5db', fontSize: 13 };
  return (
    <div style={{ maxWidth: 560 }}>
      <div style={{ background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 8, padding: '8px 12px', fontSize: 12, color: '#92400e', marginBottom: 12 }}>
        Cada pessoa recebe como <strong>mensagem individual</strong> — não é grupo. Quem envia não recebe.
      </div>
      {remetentes.length > 1 && (
        <>
          <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>De onde sai</div>
          <div style={{ display: 'flex', gap: 6, marginBottom: 10 }}>
            {remetentes.map(r => {
              const on = remetenteSel === r.id;
              const conectado = r.status === 'conectado';
              return (
                <button key={r.id || 'empresa'} type="button" onClick={() => setRemetenteSel(r.id)}
                  disabled={!conectado}
                  title={conectado ? '' : 'Desconectado — conecte em Configurações'}
                  style={{
                    flex: 1, padding: '6px 10px', fontSize: 12, fontWeight: 700, borderRadius: 6,
                    cursor: conectado ? 'pointer' : 'not-allowed', opacity: conectado ? 1 : 0.45,
                    border: '1px solid ' + (on ? '#0a1628' : '#d1d5db'),
                    background: on ? '#0a1628' : '#fff',
                    color: on ? '#fff' : '#374151',
                  }}>
                  {r.id ? '👤 ' : '🏢 '}{r.nome}{conectado ? '' : ' (off)'}
                </button>
              );
            })}
          </div>
        </>
      )}
      <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>Quem recebe</div>
      <select value={publico} onChange={e => setPublico(e.target.value)} style={{ ...inp2, width: '100%', marginBottom: publico === 'selecionados' ? 6 : 10 }}>
        <option value="todos">👥 Equipe toda</option>
        <option value="closers">🧭 Só closers</option>
        <option value="sdrs">📞 Só SDRs</option>
        <option value="selecionados">✔️ Escolher a dedo</option>
      </select>
      {publico === 'selecionados' && (
        <div style={{ border: '1px solid #d1d5db', borderRadius: 6, padding: '6px 4px', marginBottom: 10, background: '#fafafa' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 6px 4px' }}>
            <span style={{ fontSize: 11.5, color: '#6b7280' }}>{marcados.length} de {equipe.length} marcado(s)</span>
            <div style={{ display: 'flex', gap: 6 }}>
              <button type="button" onClick={() => setMarcados(equipe.map(u => u._id))} style={{ background: 'none', border: 'none', color: '#0a1628', fontSize: 11, fontWeight: 700, cursor: 'pointer' }}>marcar todos</button>
              <button type="button" onClick={() => setMarcados([])} style={{ background: 'none', border: 'none', color: '#6b7280', fontSize: 11, cursor: 'pointer' }}>limpar</button>
            </div>
          </div>
          {equipe.map(u => {
            const on = marcados.includes(u._id);
            const tTrab = (u.telefone || '').replace(/\D/g, '');
            const tPess = (u.telefone_pessoal || '').replace(/\D/g, '');
            const dois = tTrab.length >= 10 && tPess.length >= 10;
            const semTel = !(tTrab.length >= 10 || tPess.length >= 10);
            const esc = numeros[u._id] || 'ambos';
            return (
              <div key={u._id} style={{ padding: '5px 8px', borderRadius: 4, background: on ? '#eef2ff' : 'transparent' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', textAlign: 'left' }}>
                  <input type="checkbox" checked={on} style={{ width: 15, height: 15, flexShrink: 0, margin: 0, padding: 0 }}
                    onChange={() => setMarcados(m => on ? m.filter(x => x !== u._id) : [...m, u._id])} />
                  <span style={{ fontSize: 13, fontWeight: on ? 700 : 400, color: '#0a1628', whiteSpace: 'nowrap' }}>{u.nome}</span>
                  <span style={{ fontSize: 11, color: '#9ca3af', whiteSpace: 'nowrap', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>{u.cargo || ''}</span>
                  {semTel && <span style={{ fontSize: 10, color: '#b45309', whiteSpace: 'nowrap', flexShrink: 0 }}>⚠ sem telefone</span>}
                </label>
                {on && dois && (
                  <div style={{ display: 'flex', gap: 4, marginTop: 3, marginLeft: 23 }}>
                    {[['ambos', 'os dois'], ['trabalho', `trabalho ${tTrab.slice(-4)}`], ['pessoal', `pessoal ${tPess.slice(-4)}`]].map(([k, rot]) => (
                      <button key={k} type="button" onClick={() => setNumeros(n => ({ ...n, [u._id]: k }))}
                        style={{ fontSize: 10, padding: '1px 8px', borderRadius: 10, cursor: 'pointer', whiteSpace: 'nowrap',
                          border: `1px solid ${esc === k ? '#0a1628' : '#d1d5db'}`, background: esc === k ? '#0a1628' : '#fff', color: esc === k ? '#fff' : '#6b7280', fontWeight: esc === k ? 700 : 400 }}>{rot}</button>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4, gap: 8, flexWrap: 'wrap' }}>
        <span style={{ fontSize: 12, color: '#6b7280' }}>Comunicado <span style={{ color: '#9ca3af' }}>— escreva solto e deixe o ✨ arrumar</span></span>
        <div style={{ display: 'flex', gap: 6 }}>
          {antesDeFormatar && (
            <button type="button" onClick={() => { setTexto(antesDeFormatar); setAntesDeFormatar(null); }}
              style={{ background: '#fff', border: '1px solid #d1d5db', color: '#374151', borderRadius: 6, padding: '4px 10px', fontSize: 11.5, cursor: 'pointer' }}>
              ↩ Voltar ao rascunho
            </button>
          )}
          <button type="button" onClick={formatar} disabled={formatando || !texto.trim()}
            title="Reescreve o seu rascunho no padrão das mensagens da casa"
            style={{ background: formatando ? '#e5e7eb' : 'linear-gradient(135deg,#3b82f6,#8b5cf6)', color: formatando ? '#9ca3af' : '#fff', border: 'none', borderRadius: 6, padding: '4px 14px', fontSize: 11.5, fontWeight: 700, cursor: formatando || !texto.trim() ? 'default' : 'pointer', opacity: !texto.trim() ? 0.5 : 1 }}>
            {formatando ? 'Arrumando…' : '✨ Formatar'}
          </button>
        </div>
      </div>
      <textarea value={texto} onChange={e => setTexto(e.target.value)} rows={6}
        placeholder={'Escreva do seu jeito, sem se preocupar com formato. Ex.: "segunda o expediente começa 9h por causa da manutenção" — depois clique em ✨ Formatar.'}
        style={{ ...inp2, width: '100%', resize: 'vertical', boxSizing: 'border-box' }} />
      <div style={{ fontSize: 12, color: '#6b7280', margin: '10px 0 4px' }}>Enviar em <span style={{ color: '#9ca3af' }}>(vazio = agora)</span></div>
      <div style={{ marginBottom: 12 }}><CampoDataHora value={quando} onChange={setQuando} style={inp2} /></div>
      <div>
        <button onClick={enviar} disabled={enviando}
          style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 20px', fontSize: 13, fontWeight: 700, cursor: 'pointer', opacity: enviando ? 0.6 : 1 }}>
          {enviando ? 'Enfileirando…' : '📢 Enviar comunicado'}
        </button>
      </div>
      {resultado && (
        <div style={{ marginTop: 10, fontSize: 12.5, background: resultado.ok ? '#f0fdf4' : '#fef2f2', border: `1px solid ${resultado.ok ? '#bbf7d0' : '#fecaca'}`, borderRadius: 6, padding: '8px 12px', color: resultado.ok ? '#166534' : '#b91c1c' }}>
          {resultado.ok
            ? <>✅ Na fila pra <strong>{resultado.enfileirados}</strong> pessoa(s): {resultado.para.join(', ')}.
                {resultado.sem_telefone?.length > 0 && <div style={{ color: '#b45309', marginTop: 4 }}>⚠ Sem telefone no cadastro (não receberam): {resultado.sem_telefone.join(', ')}</div>}</>
            : `⚠ ${resultado.erro}`}
        </div>
      )}
    </div>
  );
}

// ── Aba Comentário no Google Negócio (06/09/2026) ─────────────────────────────
// Só clientes com registro de marca EM VIGOR (conferido na base RPI). Mostra
// quem já recebeu o pedido de avaliação, deixa filtrar enviados × não
// enviados, marcar a dedo e mandar em lote pela fila (com intervalo entre
// mensagens pra não sair em rajada).
const TEXTO_GOOGLE_PADRAO = `Oi! Sou a Clau, a inteligência artificial da Preserva Marcas.

Vi que a sua marca foi aprovada e que o certificado de registro já chegou. Parabéns, agora ela está protegida em todo o Brasil por dez anos.

Posso te pedir uma ajuda? Deixa um comentário no nosso Google contando como foi sua experiência com a Preserva. Assim outras pessoas que estão pensando em registrar a marca sabem o que esperar da gente.

É rapidinho, é só clicar aqui:
https://g.page/r/CZkXPuHB8ahXEBM/review

Obrigada!`;

function AbaGoogle({ onEnviado }) {
  const [dados, setDados] = useState({ itens: [], total: 0, enviados: 0, sem_telefone: 0 });
  const [carregando, setCarregando] = useState(true);
  const [filtro, setFiltro] = useState('nao'); // 'nao' | 'sim' | 'todos'
  const [busca, setBusca] = useState('');
  const [marcados, setMarcados] = useState([]);
  const [texto, setTexto] = useState(TEXTO_GOOGLE_PADRAO);
  const [intervalo, setIntervalo] = useState('2');
  const [quando, setQuando] = useState('');
  const [remetentes, setRemetentes] = useState([]);
  const [remetenteSel, setRemetenteSel] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const navigate = useNavigate();

  const carregar = useCallback(() => {
    setCarregando(true);
    api('/comunicacao/google-avaliacao/clientes').then(r => r.json())
      .then(d => { if (d && Array.isArray(d.itens)) setDados(d); })
      .catch(() => {})
      .finally(() => setCarregando(false));
  }, []);

  useEffect(() => {
    carregar();
    api('/comunicacao/remetentes').then(r => r.json()).then(d => setRemetentes(Array.isArray(d) ? d : [])).catch(() => {});
    // Texto oficial fica no Gerador de Mensagem (Sucesso do Cliente); se não achar, usa o padrão acima
    api('/sucesso-cliente/mensagens').then(r => r.json()).then(lista => {
      const m = (Array.isArray(lista) ? lista : []).find(x => /CLAU/i.test(x.titulo || '') && /GOOGLE/i.test(x.titulo || ''));
      if (m?.texto) setTexto(m.texto);
    }).catch(() => {});
  }, [carregar]);

  const jaEnviou = (c) => !!(c.envio && c.envio.status !== 'falhou');
  const re = busca.trim() ? new RegExp(busca.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i') : null;
  const visiveis = dados.itens.filter(c => {
    if (filtro === 'nao' && jaEnviou(c)) return false;
    if (filtro === 'sim' && !jaEnviou(c)) return false;
    if (re && !(re.test(c.nome) || c.registros.some(r => re.test(r.marca)) || re.test(c.telefone))) return false;
    return true;
  });
  const comTel = (c) => c.telefone && c.telefone.length >= 10;
  const idsVisiveis = visiveis.filter(comTel).map(c => c.cliente_id);
  const marcarTodos = () => setMarcados(m => [...new Set([...m, ...idsVisiveis])]);
  const limpar = () => setMarcados([]);
  const alternar = (id) => setMarcados(m => m.includes(id) ? m.filter(x => x !== id) : [...m, id]);

  const statusDe = (c) => {
    if (!c.envio) return { label: 'Não enviado', bg: '#f3f4f6', cor: '#6b7280' };
    const em = c.envio.em ? fmtDt(c.envio.em) : '';
    if (c.envio.status === 'enviado') return { label: `Enviado ${em}`, bg: '#f0fdf4', cor: '#16a34a' };
    if (c.envio.status === 'agendado') return { label: `Agendado ${em}`, bg: '#fffbeb', cor: '#d97706' };
    return { label: `Falhou ${em}`, bg: '#fef2f2', cor: '#dc2626' };
  };

  async function enviar() {
    if (!marcados.length) return setResultado({ erro: 'Marque pelo menos um cliente na lista.' });
    if (!texto.trim()) return setResultado({ erro: 'Escreva a mensagem.' });
    const repetidos = dados.itens.filter(c => marcados.includes(c.cliente_id) && jaEnviou(c)).length;
    const aviso = `Enviar o pedido de avaliação para ${marcados.length} cliente(s)` +
      (intervalo !== '0' ? `, um a cada ${intervalo} min` : ', todos de uma vez') +
      (repetidos ? `?\n\nAtenção: ${repetidos} deles JÁ receberam antes.` : '?');
    if (!window.confirm(aviso)) return;
    setEnviando(true); setResultado(null);
    const body = { ids: marcados, texto: texto.trim(), intervalo_min: Number(intervalo), enviar_por: remetenteSel, enviar_por_nome: remetentes.find(x => x.id === remetenteSel)?.nome || '' };
    if (quando) body.agendado_para = new Date(quando).toISOString();
    const r = await api('/comunicacao/google-avaliacao/enviar', { method: 'POST', body: JSON.stringify(body) })
      .then(x => x.json()).catch(() => ({ erro: 'Falha ao enfileirar.' }));
    setEnviando(false);
    setResultado(r);
    if (r.ok) { setMarcados([]); carregar(); onEnviado && onEnviado(); }
  }

  const naoEnviados = dados.total - dados.enviados;
  const chip = (k, rot, n) => (
    <button key={k} type="button" onClick={() => { setFiltro(k); setMarcados([]); }}
      style={{ padding: '5px 12px', fontSize: 12, fontWeight: filtro === k ? 700 : 500, borderRadius: 14, cursor: 'pointer',
        border: `1px solid ${filtro === k ? '#0a1628' : '#d1d5db'}`, background: filtro === k ? '#0a1628' : '#fff', color: filtro === k ? '#fff' : '#374151' }}>
      {rot} <span style={{ opacity: 0.75 }}>({n})</span>
    </button>
  );

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) 340px', gap: 16, alignItems: 'start' }}>
      {/* Lista */}
      <div>
        <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap', marginBottom: 10 }}>
          {chip('nao', 'Não enviados', naoEnviados)}
          {chip('sim', 'Já enviados', dados.enviados)}
          {chip('todos', 'Todos com marca em vigor', dados.total)}
          <input value={busca} onChange={e => setBusca(e.target.value)} placeholder="Buscar cliente, marca ou telefone"
            style={{ ...inp, width: 240, marginLeft: 'auto' }} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6, fontSize: 12, color: '#6b7280' }}>
          <span>{visiveis.length} cliente(s) na lista · <strong style={{ color: '#0a1628' }}>{marcados.length} marcado(s)</strong>{dados.sem_telefone ? ` · ${dados.sem_telefone} sem telefone no cadastro` : ''}</span>
          <span style={{ display: 'flex', gap: 10 }}>
            <button type="button" onClick={marcarTodos} style={{ background: 'none', border: 'none', color: '#0a1628', fontWeight: 700, fontSize: 12, cursor: 'pointer' }}>marcar todos da lista</button>
            <button type="button" onClick={limpar} style={{ background: 'none', border: 'none', color: '#6b7280', fontSize: 12, cursor: 'pointer' }}>limpar</button>
          </span>
        </div>
        {carregando ? (
          <div style={{ padding: 32, textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>Conferindo os registros na base RPI…</div>
        ) : visiveis.length === 0 ? (
          <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 8, padding: 32, textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>
            {filtro === 'nao' ? 'Todo mundo com marca em vigor já recebeu o pedido de avaliação.' : 'Nenhum cliente aqui.'}
          </div>
        ) : (
          <div style={{ border: '1px solid #e5e7eb', borderRadius: 8, overflow: 'hidden', maxHeight: 560, overflowY: 'auto' }}>
            <div style={{ background: '#0a1628', display: 'grid', gridTemplateColumns: '28px 2fr 1.6fr 1fr 150px', gap: 8, padding: '8px 12px', position: 'sticky', top: 0 }}>
              {['', 'Cliente', 'Marca(s) em vigor', 'Telefone', 'Pedido de avaliação'].map((h, i) => (
                <span key={i} style={{ fontSize: 11, fontWeight: 700, color: '#fff', textTransform: 'uppercase', letterSpacing: '0.04em' }}>{h}</span>
              ))}
            </div>
            {visiveis.map((c, i) => {
              const on = marcados.includes(c.cliente_id);
              const st = statusDe(c);
              const semTel = !comTel(c);
              return (
                <div key={c.cliente_id} onClick={() => !semTel && alternar(c.cliente_id)}
                  style={{ display: 'grid', gridTemplateColumns: '28px 2fr 1.6fr 1fr 150px', gap: 8, alignItems: 'center', padding: '8px 12px',
                    borderBottom: '1px solid #f3f4f6', background: on ? '#eef2ff' : (i % 2 === 0 ? '#fafafa' : '#fff'), cursor: semTel ? 'not-allowed' : 'pointer', opacity: semTel ? 0.6 : 1 }}>
                  <input type="checkbox" checked={on} disabled={semTel} onChange={() => alternar(c.cliente_id)} onClick={e => e.stopPropagation()} style={{ width: 15, height: 15, margin: 0 }} />
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 600, color: '#0a1628', textDecoration: 'underline', cursor: 'pointer' }}
                      onClick={e => { e.stopPropagation(); navigate(`/clientes/${c.cliente_id}/editar`); }}>{c.nome}</div>
                    {c.cidade && <div style={{ fontSize: 11, color: '#9ca3af' }}>{c.cidade}</div>}
                  </div>
                  <div style={{ fontSize: 12, color: '#374151' }}>
                    {c.registros.map(r => (
                      <div key={r.processo} title={`Processo ${r.processo} · classe ${r.classe} · vigência até ${r.vigencia}`}>{r.marca} <span style={{ color: '#9ca3af', fontSize: 11 }}>· até {r.vigencia.slice(-4)}</span></div>
                    ))}
                  </div>
                  <div style={{ fontSize: 12, color: semTel ? '#b45309' : '#374151' }}>{semTel ? '⚠ sem telefone' : c.telefone}</div>
                  <span style={{ background: st.bg, color: st.cor, padding: '2px 8px', borderRadius: 4, fontSize: 11, fontWeight: 700, justifySelf: 'start' }}>{st.label}</span>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* Painel de envio */}
      <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: 14, position: 'sticky', top: 12 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: '#0a1628', marginBottom: 8 }}>⭐ Pedido de avaliação no Google</div>
        {remetentes.length > 1 && (
          <>
            <div style={lbl}>De onde sai</div>
            <div style={{ display: 'flex', gap: 6, marginBottom: 10 }}>
              {remetentes.map(r => {
                const on = remetenteSel === r.id;
                const conectado = r.status === 'conectado';
                return (
                  <button key={r.id || 'empresa'} type="button" onClick={() => setRemetenteSel(r.id)} disabled={!conectado}
                    style={{ flex: 1, padding: '5px 8px', fontSize: 11.5, fontWeight: 700, borderRadius: 6, cursor: conectado ? 'pointer' : 'not-allowed', opacity: conectado ? 1 : 0.45,
                      border: '1px solid ' + (on ? '#0a1628' : '#d1d5db'), background: on ? '#0a1628' : '#fff', color: on ? '#fff' : '#374151' }}>
                    {r.id ? '👤 ' : '🏢 '}{r.nome}{conectado ? '' : ' (off)'}
                  </button>
                );
              })}
            </div>
          </>
        )}
        <div style={lbl}>Mensagem <span style={{ color: '#9ca3af', fontWeight: 400 }}>(pode usar {'{nome}'} e {'{marca}'})</span></div>
        <textarea value={texto} onChange={e => setTexto(e.target.value)} rows={13}
          style={{ ...inp, resize: 'vertical', lineHeight: 1.45, marginBottom: 10 }} />
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 10 }}>
          <div>
            <div style={lbl}>Intervalo entre mensagens</div>
            <select value={intervalo} onChange={e => setIntervalo(e.target.value)} style={inp}>
              <option value="0">sem intervalo</option>
              <option value="1">1 min</option>
              <option value="2">2 min</option>
              <option value="5">5 min</option>
              <option value="10">10 min</option>
            </select>
          </div>
          <div>
            <div style={lbl}>Começar em <span style={{ color: '#9ca3af', fontWeight: 400 }}>(vazio = agora)</span></div>
            <CampoDataHora value={quando} onChange={setQuando} style={inp} />
          </div>
        </div>
        <button onClick={enviar} disabled={enviando || !marcados.length}
          style={{ ...btn('#16a34a'), width: '100%', padding: '9px 0', fontSize: 13, opacity: enviando || !marcados.length ? 0.5 : 1 }}>
          {enviando ? 'Enfileirando…' : `📨 Enviar para ${marcados.length} cliente(s)`}
        </button>
        {resultado && (
          <div style={{ marginTop: 10, fontSize: 12.5, background: resultado.ok ? '#f0fdf4' : '#fef2f2', border: `1px solid ${resultado.ok ? '#bbf7d0' : '#fecaca'}`, borderRadius: 6, padding: '8px 12px', color: resultado.ok ? '#166534' : '#b91c1c' }}>
            {resultado.ok
              ? <>✅ <strong>{resultado.enfileirados}</strong> mensagem(ns) na fila{resultado.intervalo_min ? `, uma a cada ${resultado.intervalo_min} min` : ''}. Acompanhe na aba Fila.
                  {resultado.sem_telefone?.length > 0 && <div style={{ color: '#b45309', marginTop: 4 }}>⚠ Sem telefone: {resultado.sem_telefone.join(', ')}</div>}
                  {resultado.sem_registro?.length > 0 && <div style={{ color: '#b45309', marginTop: 4 }}>⚠ Sem registro em vigor: {resultado.sem_registro.join(', ')}</div>}</>
              : `⚠ ${resultado.erro}`}
          </div>
        )}
        <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 10, lineHeight: 1.4 }}>
          A lista vem do cruzamento dos processos do cadastro com a base RPI: só entra marca concedida, ativa e dentro do decênio. "Já enviado" considera esta aba e os envios do Sucesso do Cliente com o modelo de avaliação no Google.
        </div>
      </div>
    </div>
  );
}

// ── Página Principal ──────────────────────────────────────────────────────────
export default function Comunicacao() {
  // A página abre sempre na aba Agendar Envio (o uso do dia a dia);
  // Templates fica por último — é configuração, não rotina
  const [aba, setAba] = useState('agendar');
  const [recarregarFila, setRecarregarFila] = useState(0);

  const ABAS = [
    { k: 'agendar', label: '📅 Agendar Envio' },
    { k: 'comunicado', label: '📢 Comunicado' },
    { k: 'google', label: '⭐ Comentário no Google' },
    { k: 'fila', label: '⏳ Fila' },
    { k: 'historico', label: '📋 Histórico' },
    { k: 'templates', label: '📝 Templates' },
  ];

  return (
    <div style={{ maxWidth: 1000 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
        <h1 style={{ fontSize: 17, fontWeight: 700, color: '#0a1628', margin: 0 }}>💬 Comunicação WhatsApp</h1>
        <div style={{ fontSize: 12, color: '#6b7280', background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 6, padding: '4px 10px' }}>
          Mensagens disparadas automaticamente pelo servidor
        </div>
      </div>

      {/* Abas */}
      <div style={{ display: 'flex', gap: 0, marginBottom: 20, borderBottom: '2px solid #e5e7eb' }}>
        {ABAS.map(({ k, label }) => (
          <button key={k} onClick={() => setAba(k)} style={{
            background: 'none', border: 'none', borderBottom: aba === k ? '2px solid #0a1628' : '2px solid transparent',
            marginBottom: -2, padding: '8px 18px', fontSize: 13, fontWeight: aba === k ? 700 : 400,
            color: aba === k ? '#0a1628' : '#6b7280', cursor: 'pointer',
          }}>
            {label}
          </button>
        ))}
      </div>

      {aba === 'templates' && <AbaTemplates />}
      {aba === 'agendar' && <AbaAgendar onAgendado={() => { setRecarregarFila(r => r + 1); setAba('fila'); }} />}
      {aba === 'comunicado' && <AbaComunicado onEnviado={() => setRecarregarFila(r => r + 1)} />}
      {aba === 'google' && <AbaGoogle onEnviado={() => setRecarregarFila(r => r + 1)} />}
      {aba === 'fila' && <AbaFila recarregar={recarregarFila} />}
      {aba === 'historico' && <AbaHistorico />}
    </div>
  );
}
